<script setup lang="ts">
const form = useForm({
	method: 'POST',
	url: route('password.confirm'),
	fields: {
		password: '',
	},
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/security.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<ui-card-content>
		<ui-form @submit.prevent="form.submit">
			<ui-form-item>
				<ui-label for="password">
					{{ t('validation.attributes.password') }}
				</ui-label>
				<ui-input
					id="password"
					v-model="form.fields.password"
					required
					autofocus
					autocapitalize="off"
					autocomplete="current-password"
					autocorrect="off"
					type="password"
				/>
				<ui-form-error :message="form.errors.password" />
			</ui-form-item>

			<ui-button type="submit" :loading="form.processing">
				{{ t('app.buttons.confirm') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</ui-form>
	</ui-card-content>
</template>
